<!--单位信息模块-->
<template>
	<div class="powerValueViewBody">
		<div class="dayMonth">
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #409EFF;">今年总电耗</p>
				<p class="usePowerUnitBoxInfo special">{{yearPowerValue}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #67C23A;">今日电耗</p>
				<p class="usePowerUnitBoxInfo">{{day1}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #67C23A;">昨日同期</p>
				<p class="usePowerUnitBoxInfo">{{day2}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #67C23A;">上月同期</p>
				<p class="usePowerUnitBoxInfo">{{day3}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #FF9900;">本月电耗</p>
				<p class="usePowerUnitBoxInfo">{{month1}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #FF9900;">上月同期</p>
				<p class="usePowerUnitBoxInfo">{{month2}}</p>
			</div>
			<div class="usePowerUnitBlock" style="width: 10%;">
				<p class="usePowerUnitBoxTitle" style="background: #FF9900;">去年同期</p>
				<p class="usePowerUnitBoxInfo">{{month3}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: [],
		data() {
			return {
				yearPowerValue: undefined,
				day1: undefined, //今日
				day2: undefined, //上月同期
				day3: undefined, //昨日同期
				month1: undefined,
				month2: undefined,
				month3: undefined,
				monthEvent: 0,
			}
		},
		created() {},
		mounted() {
			this.getPowerValue(this.nowUnit.id)
		},
		destroyed() {},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			day2Compare() {
				return this.compareValue(this.day1, this.day2)
			},
			day3Compare() {
				return this.compareValue(this.day1, this.day3)
			},
			month2Compare() {
				return this.compareValue(this.month1, this.month2)
			},
			month3Compare() {
				return this.compareValue(this.month1, this.month3)
			},
			getImagePath() {
				return value => {
					if (value == '--' || value == 0) {
						return ''
					}
					return value > 0 ? this.getResourcesByName('unitInfo/up.png') : this.getResourcesByName('unitInfo/down.png')
				}
			},
			loadCapacity() {
				//总负荷容量
				var count = 0
				for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
					var item = this.loadDeviceList[i]
					var info = this.deviceNoToArchivesInfo[item.deviceno]
					if (!isempty(info) && !isempty(info.next)) {
						var target = info.next.find(it => it.propertyCode = "Capacity")
						if (!isempty(target) && !isempty(target.value)) {
							try {
								count += parseFloat(target.value)
							} catch (e) {}
						}
					}
				}
				return parseInt(count)
			},
		},
		watch: {
			nowUnit(nv, ov) {
				this.getPowerValue(nv.id)
			},
			unitDeviceList(nv, ov) {
				this.getMonthPowerTop(nv)
			}
		},
		methods: {
			compareValue(a, b) {
				if (a == 0 || b == 0 || a == undefined || b == undefined) {
					return "--"
				}
				return cutDigital((a - b) / b * 100) + "%"
			},
			getPowerValue(unitId) {
				if (isempty(unitId)) {
					return
				}
				var now = new Date()
				var nowTime = now.getTime()
				var year = now.getFullYear()
				var month = now.getMonth()
				var day = now.getDate()
				var nowZero = new Date(year, month, day).getTime()
				//获取今年用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, 0, 1).getTime(), nowTime, respon => {
					this.yearPowerValue = Number(respon)
				})
				//获取今日电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, nowZero, nowTime, respon => {
					this.day1 = Number(respon)
				})
				//获取昨日电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, nowZero - 24 * 60 * 60 * 1000, nowZero - 1, respon => {
					this.day2 = Number(respon)
				})
				//获取上个月同一天用电量，直接月份减1如果不存在就是空
				var lastMonthDate = new Date(year, month - 1, day)
				if (lastMonthDate.getMonth() != 12 && lastMonthDate.getMonth() != now.getMonth() - 1) {
					this.day3 = undefined
				} else {
					this.$api.powerApi.getUnitUsePowerByDate(unitId, lastMonthDate.getTime(), lastMonthDate.getTime() + 24 * 60 * 60 *
						1000 - 1, respon => {
							this.day3 = Number(respon)
						})
				}
				//获取本月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month, 1).getTime(), nowTime, respon => {
					this.month1 = Number(respon)
				})
				//获取上月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month, day)
					.getTime() -
					1, respon => {
						this.month2 = Number(respon)
					}, repon => {
						this.month2 = undefined
					})
				//获取去年同月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year - 1, month, 1).getTime(), new Date(this.getLastDay(
					year - 1, month + 1)).getTime(), respon => {
					this.month3 = Number(respon)
				}, respon => {
					this.month3 = undefined
				})
			},
			getLastDay(year, month) {
				var new_year = year; //取当前的年份          
				var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）          
				if (month > 12) {
					new_month -= 12; //月份减          
					new_year++; //年份增          
				}
				var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天          
				return year + '-' + new_month + '-' + (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月最后一天日期          
			}
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.dayMonth {
		width: 100%;
		height: 90%;
		display: flex;
		flex: 1;
		justify-content: space-around;
		align-items: center;
	}
	.usePowerUnitBoxInfo{
		border-color: #E4E4E4;
	}
</style>
